import { z } from "zod/v4";
import {
  chartExportFormatsSchema,
  vizAxisPresetSchema,
  vizPaletteModeSchema,
  vizReferenceLineSchema,
  vizSeriesArraySchema,
  vizSeriesLabelMapSchema,
  vizTooltipModeSchema,
} from "@/lib/ai/visualization/views/shared/schema-primitives";

/**
 * `scatter-plot` authoring contract。
 *
 * @remarks
 * optional binding は provider 出力でも省略可能に保ち、renderer-ready な null への
 * 正規化は compiler 側で行う。
 */
export const scatterPlotAuthoringSchema = z
  .object({
    xKey: z.string().min(1),
    xLabel: z.string().trim().min(1),
    yKey: z.string().min(1),
    yLabel: z.string().trim().min(1),
    zKey: z.string().min(1).nullable().optional(),
    seriesByKey: z.string().min(1).nullable().optional(),
  })
  .strict();

/**
 * `ScatterPlot` runtime component props schema。
 */
export const scatterPlotComponentSchema = z
  .object({
    dataPath: z.string(),
    xKey: z.string(),
    yKey: z.string(),
    zKey: z.string().optional().nullable(),
    seriesKey: z.string().optional().nullable(),
    series: vizSeriesArraySchema,
    xLabel: z.string().optional().nullable(),
    yLabel: z.string().optional().nullable(),
    seriesLabels: vizSeriesLabelMapSchema,
    axisPreset: vizAxisPresetSchema,
    tooltipMode: vizTooltipModeSchema,
    paletteMode: vizPaletteModeSchema,
    referenceLines: z
      .array(vizReferenceLineSchema)
      .max(6)
      .optional()
      .nullable(),
    allowSeriesToggle: z.boolean().optional().nullable(),
    defaultVisibleSeriesKeys: z.array(z.string()).optional().nullable(),
    allowExport: z.boolean().optional().nullable(),
    exportFormats: chartExportFormatsSchema,
  })
  .strict();
